import Header from "components/Atoms/SharedComponents/Details/header";
import { Stack, Typography } from "@mui/material";
import { useThemePalette } from "common/hooks/theme_palette";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useRef } from "react";
import CActions from "components/Molecules/Crud/components/actions";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function ProductDetailsHeader({ data, setOpenDeleteModal }) {
  const { t } = useTranslation();
  const currentUser = useSelector(
    (state) => state.authenticate.currentUserProfile,
  );
  const permissions = useSelector(
    (state) => state.authenticate.currentUserProfile.permissions.products,
  );

  const isSuperAdmin = currentUser?.privilege == "super_admin";
  const status = data?.approval_status;
  const navigate = useNavigate();
  const location = useLocation();
  const isEventService = location.pathname.includes("/events/services");
  const basePath = isEventService ? "/events/services" : "/products";
  const { green, red } = useThemePalette();

  const [anchorEl, setAnchorEl] = useState(null);
  const anchorRef = useRef(null);
  const open = Boolean(anchorEl);
  const handleClick = (event, index, data) => {
    anchorEl == index ? setAnchorEl(null) : setAnchorEl(index);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const actionsList = () => {
    return [
      {
        condition: () => {
          return (
            (status == "available" || isEventService) &&
            (isSuperAdmin || permissions?.can_update)
          );
        },
        click: () => {
          navigate(`${basePath}/${data?.id}?type=edit`);
        },
        text: isEventService
          ? t("events_services.action_edit")
          : t("products.action_edit"),
      },
      {
        condition: () => {
          return isSuperAdmin || permissions?.can_delete;
        },
        click: () => {
          setOpenDeleteModal(true);
        },
        text: isEventService
          ? t("events_services.action_delete")
          : t("products.action_delete"),
      },
    ];
  };

  const headerChildren = (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      gap={2}
      alignItems={{ xs: "flex-start", sm: "center" }}
    >
      <Stack direction="row">
        <Stack direction="row" gap={1}>
          <Typography sx={{ color: "#9C9C9C" }}>
            {t("vendors.label_account_status_colon")}
          </Typography>
          {data?.is_visible ? (
            <Typography sx={{ color: green, fontSize: "18px" }}>
              {t("vendors.status_active")}
            </Typography>
          ) : (
            <Typography
              sx={{ color: red, fontSize: "18px", textTransform: "capitalize" }}
            >
              {t("vendors.status_disabled")}
            </Typography>
          )}
        </Stack>
      </Stack>
      <Stack direction="row">
        <Stack direction="row" gap={1}>
          <Typography sx={{ color: "#9C9C9C" }}>
            {t("vendors.label_approval_status_colon")}
          </Typography>
          {status == "available" ? (
            <Typography sx={{ color: green, fontSize: "18px" }}>
              {t("vendors.status_approved")}
            </Typography>
          ) : (
            <Typography
              sx={{ color: red, fontSize: "18px", textTransform: "capitalize" }}
            >
              {status}
            </Typography>
          )}
        </Stack>
      </Stack>
      {status !== "deleted" && actionsList().length !== 0 && (
        <Stack>
          <CActions
            id={data?.id}
            index={1}
            data={data}
            handleClick={handleClick}
            handleClose={handleClose}
            anchorRef={anchorRef}
            open={open}
            anchorEl={anchorEl}
            actionsList={actionsList}
          />
        </Stack>
      )}
    </Stack>
  );
  return (
    <Header
      title={
        isEventService
          ? t("events_services.details")
          : t("products.breadcrumb_product_details")
      }
      children={headerChildren}
      deleteBtn={false}
      editBtn={false}
      // setOpenDeleteModal={setOpenDeleteModal}
    />
  );
}
